import { Box, BoxProps } from '@mui/material';
import { ComponentPropsWithoutRef, FC } from 'react';

import { styled } from '@mui/material/styles';

type CircularIconContainerProps = {
  shapeContainerProps?: ComponentPropsWithoutRef<typeof StylizedCircle>;
  contentContainerProps?: ComponentPropsWithoutRef<typeof StylizedCircleContentContainer>;
};

export const CircularIconContainer: FC<CircularIconContainerProps> = ({
  children,
  shapeContainerProps = {},
  contentContainerProps = {},
}) => (
  <StylizedCircle {...shapeContainerProps}>
    <StylizedCircleContentContainer {...contentContainerProps}>{children}</StylizedCircleContentContainer>
  </StylizedCircle>
);

const StylizedCircle = styled(Box)<BoxProps>(({ theme }) => ({
  height: '80px',
  width: '80px',
  display: 'flex',
  justifyContent: 'center',
  borderRadius: '50%',
  backgroundColor: theme.palette.helix.yellowLight,
}));

const StylizedCircleContentContainer = styled(Box)<BoxProps>({
  paddingTop: '26px',
  paddingBottom: '20px',
});
